import React from "react";
import css from './Loader.module.scss';

export default function Loader() {
    return (
        <div className={css.loader}>
            <div className={css.main}>
                <div className={css.row}></div>
                <div className={css.row}></div>
                <div className={css.row}></div>
            </div>
        </div>
    );
}
